module.exports = __webpack_public_path__ + "3a00a4b6072f5745f9454f78ad590ab5.svg";